import destroyAllForms from 'redux/domain/Forms/actions';
import toJS from 'shared/components/toJS';
import withAsyncId from 'shared/components/withAsyncId';
import { getBrandInfo } from 'redux/domain/BrandInfo';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { destroyAllStatuses } from 'redux/domain/AppStatus/creators';
import {
	setAppIndividual,
	setAppJoint,
	setReturnedFromThirdPartySite,
	setUserConsented,
	setAdditionalProviderReviewCheckboxDisplayed,
	setCFATraceId,
} from 'redux/domain/Welcome/creators';
import {
	destroyCustomerIdAndResultCode,
	setCustomerId,
} from 'redux/domain/TermsAndConditions/creators';
import { fetchSettings } from 'redux/domain/Settings/actions';
import withRouter from '../../shared/utils/WithRouter';
import { destroyApplicationFormData } from 'redux/domain/App';
import Welcome from './Welcome';

const mapStateToProps = state => ({
	brandInfo: state.brandInfo.get('brandInfo'),
	settings: state.cache.get('settings'),
	salespersonId: state.app.get('salespersonId'),
	providerId: state.welcome.get('providerId'),
	storeName: state.welcome.get('storeName'),
	defaultProvider: state.welcome.get('defaultProvider'),
});

const makeMapDispatchToProps = (initialState, initialProps) => {
	const { asyncId } = initialProps;
	const mapDispatchToProps = dispatch =>
		bindActionCreators(
			{
				getBrandInfo: () => getBrandInfo(asyncId),
				fetchSettings: (locationId, cfaTraceId) => fetchSettings(asyncId, locationId, cfaTraceId),
				destroyAllForms,
				destroyAllStatuses,
				destroyCustomerIdAndResultCode,
				setCustomerId,
				setAppIndividual,
				setAppJoint,
				setReturnedFromThirdPartySite,
				destroyApplicationFormData,
				setUserConsented,
				setAdditionalProviderReviewCheckboxDisplayed,
				setCFATraceId,
			},
			dispatch,
		);
	return mapDispatchToProps;
};

// generate a route-aware container component
const WelcomeContainer = withRouter(
	withAsyncId(connect(mapStateToProps, makeMapDispatchToProps)(toJS(Welcome))),
);

export default WelcomeContainer;
export { mapStateToProps, makeMapDispatchToProps }; // for testing purposes only
